import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PrefixSimplifiedType } from '../../interfaces/Prefix'
import { getResponsibles } from '../../../httpClient/Requests/Api/TEMPO/system'
import { LookupState } from '../../interfaces/LookupState'
import { Lookup } from '../../../httpClient/interfaces/Lookup'

export const initialState: LookupState = {
    data: [],
    loading: false,
    error: null,
}

export const fetchResponsibles = (prefix: PrefixSimplifiedType) =>
    createAsyncThunk(`${prefix}/responsibles/fetchResponsibles`, async () => {
        let responsibles: Lookup[] = []
        if (prefix.includes('TEMPO')) {
            const response = await getResponsibles()
            responsibles = response.data
        }
        return responsibles
    })

const responsiblesSlice = (prefix: PrefixSimplifiedType) =>
    createSlice({
        name: `${prefix}/responsibles`,
        initialState,
        reducers: {},
        extraReducers: (builder) => {
            builder.addCase(fetchResponsibles(prefix).pending, (state) => ({ ...state, loading: true, error: null }))
            builder.addCase(fetchResponsibles(prefix).fulfilled, (state, action) => ({
                ...state,
                data: action.payload,
                loading: false,
                error: null,
            }))
            builder.addCase(fetchResponsibles(prefix).rejected, (state, action) => ({
                ...state,
                loading: false,
                error: action.error,
            }))
        },
    })

const responsibles = (prefix: PrefixSimplifiedType) => responsiblesSlice(prefix).reducer

export default responsibles
